export const mergeHourSegments = segments => {
  const sorted = [...(segments || [])]
    .filter(segment => segment.end > segment.start)
    .sort((left, right) => left.start - right.start)

  const merged = []
  sorted.forEach(segment => {
    const last = merged[merged.length - 1]
    if (!last || segment.start > last.end) {
      merged.push({ start: segment.start, end: segment.end })
      return
    }
    last.end = Math.max(last.end, segment.end)
  })

  return merged
}

export const getOutsideBookableHourSegments = ({
  recurring = [],
  override = [],
  startHour,
  endHour,
}) => {
  const bookable = mergeHourSegments([
    ...recurring.map(segment => ({ start: segment.start, end: segment.end })),
    ...override.map(segment => ({ start: segment.start, end: segment.end })),
  ])

  const outside = []
  let cursor = startHour

  bookable.forEach(segment => {
    const clampedStart = Math.max(segment.start, startHour)
    const clampedEnd = Math.min(segment.end, endHour)
    if (clampedEnd <= clampedStart) return

    if (clampedStart > cursor) {
      outside.push({ start: cursor, end: clampedStart })
    }
    cursor = Math.max(cursor, clampedEnd)
  })

  if (cursor < endHour) {
    outside.push({ start: cursor, end: endHour })
  }

  return outside
}

export const formatFractionalHour = hour => {
  const hour24 = Math.floor(hour)
  const minute = Math.round((hour - hour24) * 60)
  const period = hour24 >= 12 ? 'PM' : 'AM'
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12

  if (minute === 0) {
    return `${hour12} ${period}`
  }

  return `${hour12}:${String(minute).padStart(2, '0')} ${period}`
}

export const formatFractionalHourRange = (start, end) =>
  `${formatFractionalHour(start)} – ${formatFractionalHour(end)}`

export const isHourOutsideBookable = (hour, recurring = [], override = []) => {
  const bookable = mergeHourSegments([
    ...recurring.map(segment => ({ start: segment.start, end: segment.end })),
    ...override.map(segment => ({ start: segment.start, end: segment.end })),
  ])

  if (!bookable.length) {
    return true
  }

  const hourStart = hour
  const hourEnd = hour + 1

  return !bookable.some(
    segment => segment.end > hourStart && segment.start < hourEnd,
  )
}
